'use strict';

console.log('BCAME')

const merge = (a, b, predicate = (a, b) => a === b) => {
  const c = [...a]; // copy to avoid side effects
  // add all items from B to copy C if they're not already present
  b.forEach((bItem) => (c.some((cItem) => predicate(bItem, cItem)) ? null : c.push(bItem)))
  return c;
}
document.addEventListener("DOMContentLoaded", function() {
  // Save initial order items
  const initialItems = Array.from(document.querySelectorAll('.magazine-item'));
  let tagsArray = [];

  // Port attribute from article to parent div and create tags array
  document.querySelectorAll('.magazine-item').forEach(magazineItem => {
    const item = magazineItem.querySelector('.article');
    const ctaLink = magazineItem.querySelector('.article-link');
    const ctaLinkImg = magazineItem.querySelector('.article-link-img');
    const tags = item.getAttribute('tags');
    if (tags) {
      let tagsSplitted = tags.split(',');

      tagsSplitted.forEach((tag, index) => {
        tagsSplitted[index] = tag.trim(); 
      });

      magazineItem.setAttribute('tags', tags);
      tagsArray = merge(tagsArray, tagsSplitted)
    }

    if (item.getAttribute('featured') == 'true') {
      magazineItem.classList.add('featured')
    }

    if (item.getAttribute('publishdate') && item.getAttribute('publishdate') !== 'false') {
      magazineItem.setAttribute('publishdate', item.getAttribute('publishdate'));
    } else {
      magazineItem.setAttribute('publishdate', '01-01-1970');
    }

    if (ctaLink) {
      var currentLink = ctaLink.getAttribute('data-href');
      const url = new URL(currentLink);
      url.searchParams.append('fromMagazine', 'true');
      ctaLink.setAttribute('href', url);
      ctaLink.removeAttribute('data-href');
    }

    if (ctaLinkImg) {
      var currentLinkImg = ctaLinkImg.getAttribute('data-href');
      const urlImg = new URL(currentLinkImg);
      urlImg.searchParams.append('fromMagazine', 'true');
      ctaLinkImg.setAttribute('href', urlImg);
      ctaLinkImg.removeAttribute('data-href');
    }

  });

  // Create default button VIEW ALL
  const btnDefault = document.createElement('button');
  btnDefault.classList.add('btn')
  btnDefault.classList.add('btn-boxed')
  btnDefault.classList.add('btn-tag')
  btnDefault.classList.add('active')
  btnDefault.innerHTML = document.querySelector('.tags').getAttribute('view-all-text');
  btnDefault.addEventListener('click', function (event) {
    initialItems.forEach(item => {
      document.querySelectorAll('.btn-tag').forEach(btn => {
        btn.classList.remove('active')
      });
      btnDefault.classList.add('active')
      item.classList.remove('d-none');
    });
    applyMasonryLayout();
  });
  document.querySelector('.tags').appendChild(btnDefault);

  // Create other button tags
  tagsArray.forEach(tag => {
    let btn = document.createElement('button');
    btn.classList.add('btn')
    btn.classList.add('btn-boxed')
    btn.classList.add('btn-tag')
    btn.innerHTML = tag;
    btn.addEventListener('click', function (event) {
      initialItems.forEach(item => {
        item.classList.remove('d-none')
        if (!item.getAttribute('tags') || item.getAttribute('tags').indexOf(tag) < 0) {
          item.classList.add('d-none')
        }
        document.querySelectorAll('.btn-tag').forEach(buttons => {
          buttons.classList.remove('active')
        });
        btn.classList.add('active')
      });
      applyMasonryLayout();
    });
    document.querySelector('.tags').appendChild(btn);
  });

  function applyMasonryLayout() {
    const container = document.querySelector('.magazine-container');
    const columnCount = window.innerWidth < 768 ? 1 : 4; // Use a single column on mobile, 4 in desktop
    container.innerHTML = ''; // Reset container for reassign

    const columns = Array.from({ length: columnCount }, () => document.createElement('div'));

    // Add class column to every column and append into container
    columns.forEach(column => {
      column.classList.add('column');
      container.appendChild(column);
    });

    let columnIndex = 0; // Current index column

    // Assing articles inside column based on initial order

    // Sort elements most recently
    if (document.querySelector('.page-magazine').getAttribute('orderbydate') === 'true') {
      initialItems.sort((a, b) => {
        const dateA = new Date(a.getAttribute('publishdate').split('-').reverse().join('-'));
        const dateB = new Date(b.getAttribute('publishdate').split('-').reverse().join('-'));
        return dateB - dateA; // Ordine decrescente
      });
    }

    // `initialItems` è ora ordinato per data dalla più recente alla meno recente
    initialItems.forEach((item) => {
      if (!item.classList.contains('d-none')) {
        if (item.classList.contains('featured') && columnCount > 1) {
          // Remove class "featured" if element is positioned in last column
          if ((columnIndex % columnCount) === columnCount - 1) {
            item.classList.remove('featured');
            item.style.width = '100%'; // Reset width
          } else {
            // set double width for occupy two column
            item.style.width = 'calc(200% + 16px)';

            // Check if previous element in next column is taller than current column
            const previousInNextColumn = columns[(columnIndex + 1) % columnCount].lastElementChild;
            const previousHeight = previousInNextColumn ? previousInNextColumn.getBoundingClientRect().height : 0;
            const currentColumnPreviousHeight = columns[columnIndex % columnCount].lastElementChild ? columns[columnIndex % columnCount].lastElementChild.getBoundingClientRect().height : 0;

            // Add a spacer above the featured article if next column is taller than current column
            if (previousHeight > currentColumnPreviousHeight) {
              const alignmentSpacer = document.createElement('div');
              alignmentSpacer.classList.add('alignment-spacer');
              alignmentSpacer.style.height = (previousHeight - currentColumnPreviousHeight - 40) + 'px';
              columns[columnIndex % columnCount].appendChild(alignmentSpacer);
            }
    
            // Insert "featured" article inside current column
            columns[columnIndex % columnCount].appendChild(item);

            // Create a placeholder withou set height (set height in second loop)
            const spacer = document.createElement('div');
            spacer.classList.add('spacer');
            columns[(columnIndex + 1) % columnCount].appendChild(spacer);

            // Skip two column for "featured" articles
            columnIndex += 2;
            return; // next element
          }
        }

        // Position articles non featured without placeholder
        item.style.width = '100%'; // Set normal width
        columns[columnIndex % columnCount].appendChild(item);
        columnIndex += 1; // next element
      }
    });

    // second loop: Set height of placeholders based on height of feature article correspondent
    columns.forEach((column, colIndex) => {
      const itemsInColumn = Array.from(column.children);
      
      itemsInColumn.forEach((item, rowIndex) => {
        if (item.classList.contains('spacer')) {
          // find the "featured" article in previous column in the same position
          const featuredItem = columns[(colIndex - 1 + columnCount) % columnCount].children[rowIndex];
          if (featuredItem && featuredItem.classList.contains('featured')) {
            // set height of placeholder equal to featured article correspondent
            item.style.height = featuredItem.getBoundingClientRect().height + 'px';
          }
        }
      });
    });

    document.querySelector('.overlay').classList.remove('loading');
  }

  // Apply initial masonry layout
  applyMasonryLayout();

  // repeat on resize with debounce
  let resizeTimeout;
  window.addEventListener('resize', () => {
    clearTimeout(resizeTimeout);
    resizeTimeout = setTimeout(() => {
      applyMasonryLayout();
    }, 200);
  });
});